import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
export const wrapper = css`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 4px;
  flex-wrap: wrap;
`;

const commonStyle = css`
  ${MQ.MobileXs} {
    ${ZeeFontRegular(12, 18)};
  }
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 22)};
  }
`;

export const keyStyle = css`
  ${commonStyle};
  ${MQ.MobileXs} {
    color: ${colors.greyNeutral};
  }
  ${MQ.MediaMd} {
    color: ${colors.greyText};
  }
`;
export const valueStyle = (textColor: string, link?: string) => css`
  ${commonStyle};
  ${!link ? `color: ${textColor};` : `color:${colors.Lavender};cursor:pointer;`}
`;
